import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect } from "react";
import TextInput from "components/files/TextInput";
import CustomIconButton from "components/CustomIconButton";
import { Add, Done } from "@mui/icons-material";
import CustomCard from "components/CustomCard";
import { Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import CustomDataGrid from "components/customDataGrid";
import { useState } from "react";
import CustomDialog from "components/CustomDialog";
import http from "../../../../http";
import { apiUrl } from "config/settings";
import { endpointName } from "containers/servicesCall/const";
import useDataManager from "hooks/useDataManager";
import { onlyNumber } from "utils/validations";
import CheckBoxInput from "components/files/CheckBoxInput";

const Parts = ({ data, list, setList }) => {
    const { bt } = useBizTypeTranslation();
    const { addItem, editItem } = useDataManager();
    const { reset, handleSubmit, control, formState: { errors } } = useForm();
    const [openDialog, setOpenDialog] = useState(false)

    const openPart = (part) => {
        reset({
            id: part?._id,
            requested: part?.requested,
            collected: part?.collected,
            qty: part?.qty,
            name: part?.name,
        })
        setOpenDialog(true)
    }

    const onSubmitPart = (values) => {
        try {
            const part = { ...values }
            http.patch(`${apiUrl}/${endpointName}/${values?.id ? "updatePart" : "createPart"}/${data?.id}`, part)
                .then(res => {
                    if (res?.status === 200) {
                        if (part?.id) setList(editItem(part, list))
                        else setList(addItem(res?.data, list))
                    }
                })
            closeDialog()

        }
        catch (error) {
            console.log("error", error);
        }
    }

    const closeDialog = () => {
        reset({
            name: "",
            qty: null,
            requested: false,
            ordered: false,
            arrived: false,
            collected: false,
        })
        setOpenDialog(false)
    }

    return (
        <CustomCard width="100%">
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography fontSize={14}>{bt("PARTS")}:</Typography>
                <CustomIconButton hideBgcolor icon={<Add />} size={30} onClick={() => setOpenDialog(true)} />
            </Stack>

            <CustomDataGrid
                width="100%"
                minHeight={50}
                setItem={(i) => openPart(i)}
                columns={[
                    {
                        field: 'name',
                        headerName: bt("PART_NAME"),
                        width: 150,
                        filterable: false,
                    },
                    {
                        field: 'qty',
                        headerName: bt("QTY"),
                        width: 60,
                        filterable: false,
                    },
                    {
                        field: 'supplier',
                        headerName: bt("SUPPLIER"),
                        width: 100,
                        filterable: false,
                    },
                    {
                        field: 'po',
                        headerName: bt("PO"),
                        width: 100,
                        filterable: false,
                    },
                    {
                        field: 'requested',
                        headerName: bt("REQUESTED"),
                        width: 100,
                        filterable: false,
                        renderCell: (values) => {
                            return (
                                values?.row?.requested
                                    ? <Done fontSize="small" sx={{ color: "success.main" }} />
                                    : ""
                            )
                        },
                    },
                    {
                        field: 'ordered',
                        headerName: bt("ORDERED"),
                        width: 80,
                        filterable: false,
                        renderCell: (values) => {
                            return (
                                values?.row?.ordered
                                    ? <Done fontSize="small" sx={{ color: "success.main" }} />
                                    : ""
                            )
                        },
                    },
                    {
                        field: 'arrived',
                        headerName: bt("ARRIVED"),
                        width: 80,
                        filterable: false,
                        renderCell: (values) => {
                            return (
                                values?.row?.arrived
                                    ? <Done fontSize="small" sx={{ color: "success.main" }} />
                                    : ""
                            )
                        },
                    },
                    {
                        field: 'collected',
                        headerName: bt("COLLECTED"),
                        width: 80,
                        filterable: false,
                        renderCell: (values) => {
                            return (
                                values?.row?.collected
                                    ? <Done fontSize="small" sx={{ color: "success.main" }} />
                                    : ""
                            )
                        },
                    },
                ]}

                list={list?.map((w) => ({
                    ...w,
                    id: w?._id,
                    supplier: w?.supplier?.name
                })
                )}
                hideFooter
            />

            <CustomDialog
                title="PART"
                open={openDialog}
                onClose={() => closeDialog()}
                actionBtn={{ title: bt("SAVE"), onClick: () => handleSubmit(onSubmitPart)() }}
            >
                <form onSubmit={handleSubmit(onSubmitPart)}>

                    <Stack spacing={2}>
                        <TextInput
                            control={control}
                            name={`name`}
                            title="NAME"
                        />

                        <TextInput
                            control={control}
                            name={`qty`}
                            title="QTY"
                            validation={onlyNumber}
                        />

                        <Stack direction="row" spacing={1}>

                            <CheckBoxInput
                                control={control}
                                name={`requested`}
                                title="REQUESTED"
                            // readOnly={!MANAGER.includes(userRole)}
                            />

                            <CheckBoxInput
                                control={control}
                                name={`collected`}
                                title="COLLECTED"
                            />

                        </Stack>
                    </Stack>

                </form>
            </CustomDialog>
        </CustomCard>
    )
};

export default Parts;
